import {
  Bell,
  Home,
  ReceiptText,
  Wallet,
  UserCircle,
  type LucideIcon,
} from "lucide-react";
import { paths } from "../routes/paths";

// Port des onglets de ClientStack.tsx (createBottomTabNavigator).
// Sur natif : tab bar en bas. Sur web : tab bar < md, sidebar ≥ md (§6).
//
// Les icônes Ionicons (@expo/vector-icons) sont remplacées par lucide-react —
// même logique d'icône outline, mais en SVG DOM et tree-shakable.

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
};

export const CLIENT_NAV: NavItem[] = [
  { to: paths.home(), label: "Accueil", icon: Home },
  { to: paths.orders(), label: "Commandes", icon: ReceiptText },
  { to: paths.wallet(), label: "Portefeuille", icon: Wallet },
  { to: paths.profile(), label: "Profil", icon: UserCircle },
];

// Liens accessibles à une Main lorsqu'elle gère également une vitrine.
export const AGENT_NAV: NavItem[] = [
  { to: paths.agentHome(), label: "Accueil", icon: Home },
  { to: paths.agentGains(), label: "Mes gains", icon: Wallet },
  { to: paths.agentNotifications(), label: "Notifications", icon: Bell },
];
